import React, { useRef } from "react";

const VerticalScrollImage = ({ src, size = 300, scrollSpeed = 1 }) => {
  const imgRef = useRef(null);
  const scrollInterval = useRef(null);

  const handleMouseEnter = () => {
    const img = imgRef.current;
    if (!img) return;

    scrollInterval.current = setInterval(() => {
      if (img.scrollTop < img.scrollHeight - img.clientHeight) {
        img.scrollTop += scrollSpeed;
      } else {
        img.scrollTop = 0; // reset to top
      }
    }, 20);
  };

  const handleMouseLeave = () => {
    clearInterval(scrollInterval.current);
  };

  return (
    <div
      ref={imgRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        overflow: "hidden",
        borderRadius: "16px",
        boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
        position: "relative",
        cursor: "pointer",
      }}
    >
      <img
        src={src}
        alt="scrolling"
        style={{
          width: "100%",
          height: "auto",
          display: "block",
          objectFit: "cover",
        }}
      />
    </div>
  );
};

export default VerticalScrollImage;
